import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseService } from '@app/shared/services';
import { environment } from '@environments/environment';
import { ResponseResult } from '@app/auth/model';

@Injectable({
  providedIn: 'root',
})
export class AuctionService extends BaseService {
  private customEndpointPrefix: string;
  constructor(private http2: HttpClient) {
    super(http2, 'admin', 'auction');
    this.customEndpointPrefix = `${environment.urlAPI}/admin/auction`;
  }
  summaryAdmin(): any {
    return this.http2.get<ResponseResult>(
      `${this.customEndpointPrefix}/summary/admin`
    );
  }

  summaryTeacher(): any {
    return this.http2.get<ResponseResult>(
      `${this.customEndpointPrefix}/summary/teacher`
    );
  }
}
